import { render, staticRenderFns } from "./ClassesDetail.vue?vue&type=template&id=08e835ee&scoped=true&"
import script from "./ClassesDetail.vue?vue&type=script&lang=js&"
export * from "./ClassesDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClassesDetail.vue?vue&type=style&index=0&id=08e835ee&lang=scss&scoped=true&"
import style1 from "./ClassesDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e835ee",
  null
  
)

export default component.exports